import { Transaction } from "../../../domain/types/Transaction";

export const formatCurrency = (amount: number, currency = "USD"): string => {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency,
  }).format(amount);
};

export const getTextColor = (type?: string): string => {
  const colors = {
    Income: "text-green-600 dark:text-green-400",
    Expense: "text-red-600 dark:text-red-400",
    Transfer: "text-yellow-600 dark:text-yellow-400",
    Payment: "text-purple-600 dark:text-purple-400",
    Unknown: "text-gray-600 dark:text-gray-400",
  };
  return colors[type as keyof typeof colors] || colors.Unknown;
};

export const groupTransactions = (
  transactions: Transaction[],
  groupBy: "date" | "merchant" | "category" | "none",
): Record<string, Transaction[]> => {
  if (groupBy === "none") return { all: transactions };

  return transactions.reduce(
    (groups, transaction) => {
      const key = getGroupKey(transaction, groupBy);
      if (!groups[key]) groups[key] = [];
      groups[key].push(transaction);
      return groups;
    },
    {} as Record<string, Transaction[]>,
  );
};

const getGroupKey = (
  transaction: Transaction,
  groupBy: "date" | "merchant" | "category" | "none",
): string => {
  switch (groupBy) {
    case "date":
      return new Date(transaction.transaction_date).toLocaleDateString();
    case "merchant":
      return transaction.merchant_name || "Unknown Merchant";
    case "category":
      return transaction.category_description || "Uncategorized";
    default:
      return "all";
  }
};
